<template>
  <v-app :style="{ background: '#f5f7fa' }">
    <SuperiorMenu />

    <v-main>
      <!-- Contenedor Principal -->
      <v-container fluid class="fill-height align-start pa-0">
        <v-fade-transition mode="out-in">
          
          <!-- CASO 1: Selector de Cliente para Ramos -->
          <div v-if="esRamos && !$route.meta.hideClientSelector && !esRutaMantenimiento" class="w-full" style="width: 100%">
            
            <!-- Banner de Selección de Cliente COMPACTO y SIN LÍMITES DE ANCHO -->
            <v-sheet v-if="!bloqueoQR" elevation="1" class="py-2 px-4 border-bottom" color="white">
              <v-row align="center" no-gutters>
                <!-- Título a la izquierda para ahorrar espacio vertical -->
                <v-col cols="12" sm="auto" class="pr-4 hidden-xs-only">
                  <div class="text-subtitle-1 font-weight-bold primary--text">Panel de Gestión</div>
                </v-col>

                <!-- Buscador ocupando el resto del espacio -->
                <v-col>
                  <v-autocomplete
                    v-model="clienteSeleccionado"
                    :items="clientes"
                    item-text="nombre"
                    item-value="id_cliente"
                    label="Seleccionar cliente..."
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    hide-details
                    flat
                    background-color="grey lighten-4"
                    clearable
                    class="rounded-lg custom-autocomplete"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{ item.nombre }}</v-list-item-title>
                        <v-list-item-subtitle class="caption">ID: {{ item.id_cliente }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-sheet>

            <!-- Área de Contenido (Cambiado a FLUID y pa-0 para eliminar márgenes laterales) -->
            <v-container fluid class="pa-0">
              <v-scroll-y-transition mode="out-in">
                <div v-if="clienteSeleccionado" :key="clienteSeleccionado">
                  <router-view />
                </div>
                
                <!-- Estado Vacío -->
                <v-row v-else justify="center" class="mt-12 mx-0">
                  <v-col cols="12" sm="8" md="6" class="text-center">
                    <v-icon size="80" color="grey lighten-2">mdi-account-search-outline</v-icon>
                    <h3 class="text-h6 grey--text mt-4">Selecciona un cliente para comenzar</h3>
                  </v-col>
                </v-row>
              </v-scroll-y-transition>
            </v-container>
          </div>

          <!-- CASO 2: Usuario Normal (Se mantiene como estaba) -->
          <v-container v-else fluid class="pa-0">
            <router-view />
          </v-container>

        </v-fade-transition>
      </v-container>
    </v-main>

    <DialogosGlobales />
  </v-app>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SuperiorMenu from "@/components/layout/SuperiorMenu.vue";
import DialogosGlobales from "@/components/layout/DialogosGlobales.vue";
import axios from "axios";

export default {
  name: "App",
  components: { SuperiorMenu, DialogosGlobales },

  data() {
    return {
      mounted: false,
      clienteSeleccionado: this.$store.state.idCliente || localStorage.getItem("clienteSeleccionado") || null,
    };
  },

  computed: {
    ...mapState(["all_articles", "idCliente", "esRamos", "clientes", "bloqueoQR"]),
    esRutaMantenimiento() {
      return this.$route.path.startsWith('/mantenimiento');
    },
    // QR a resolver solo cuando el usuario es Ramos (los demás ya tienen su cliente fijo)
    qrRamos() {
      return this.esRamos ? this.$route.query.qr || null : null;
    },
  },

  methods: {
    ...mapActions(["postDataWithReturn", "setAllArticles", "setOrders","setEsRamos",'setClientId', 'retrieveToken', 'retrieveClientId', "storePartnerId", "storeIdCliente", "storeUserAfterCharge", "getData"]),
    ...mapGetters(["getPartnerId", "getIdCliente"]),
    
    async getArticles(partner_id) {
      if (!this.all_articles?.length && partner_id != null) {
        // partner_id = 70 //borrar
        const { artículos: articles } = await this.postDataWithReturn({ path: "django/portal/articulos/", body: { partner_id: partner_id } });
        const { orders } = await this.getData({ path: `django/portal/get_orders/?partner_id=${partner_id}` });

        // articles.map((a) => a.qty_available = 100); //borrar
        this.setAllArticles(articles.map((a) => ({ quantity: a.qty_available > 0 ? 1 : 0, in_cart: false, note: a.qty_available > 0 ? false : true,...a })));
        this.setOrders(orders);
      }
    },
  },

  created() {
    // retrieveClientId rellena esRamos, permisos e idCliente de forma síncrona (antes de su primer await),
    // así las páginas hijas se montan ya con el estado correcto al recargar
    this.clientesCargados = this.retrieveClientId();
  },

  async mounted() {
    await this.clientesCargados;

    let partner_id = this.getPartnerId();   
    try {
  
      if(!this.esRamos){
        this.getArticles(partner_id);
      }
  
      this.mounted = true;
    } catch(e) {
      console.error("errror al cargar datos", e);
    }

  },

  watch: {
    clienteSeleccionado(v) {
      this.setClientId(v);
    },
    // el selector refleja siempre el cliente del store (login, logout, cambio por QR desde Armarios...)
    idCliente(v) {
      if (v != this.clienteSeleccionado) this.clienteSeleccionado = v || null;
    },
    // depende también de esRamos: tras el login la query ?qr no cambia (viene de /login?qr=...),
    // pero esRamos pasa a true y el cliente se ha vaciado, así que hay que volver a resolverlo
    qrRamos: {
      immediate: true,
      async handler(qr) {
        if (!qr) return;
        try {
          const res = await axios.get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/cliente/${qr}`);
          const idDetectado = parseInt(res.data?.client_id, 10);
          if (idDetectado) this.clienteSeleccionado = idDetectado;
        } catch (e) {
          console.error("No se pudo resolver el cliente del QR", e);
        }
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* Línea sutil para separar el selector del contenido */
.border-bottom {
  border-bottom: 1px solid #e0e0e0 !important;
}

.custom-autocomplete >>> .v-input__control {
  border-radius: 8px !important;
}

/* Ajuste para que el texto del autocomplete no se vea apretado */
.custom-autocomplete >>> .v-input__slot {
  min-height: 40px !important;
}

.w-full {
  width: 100%;
}
</style>